import {HttpClient} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {WalletHistory} from '../../models/wallet';
import {ENVIRONMENT} from 'src/environments/environment.token';
import {switchMap, tap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})

export class WalletHistoryService {
  private http = inject(HttpClient);
  private readonly environment = inject(ENVIRONMENT);
  private walletHistoryRefreshTrigger$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  constructor() { }

  refreshWalletHistory() {
    this.walletHistoryRefreshTrigger$.next(true);
  }

  private _walletHistory: WalletHistory[] = [];

  get walletHistory(): WalletHistory[] {
    return this._walletHistory;
  }

  getWalletHistory(policyGroupId: number | string, userId: number): Observable<WalletHistory[]> {
    return this.walletHistoryRefreshTrigger$.pipe(
      switchMap(() => {
        return this.http.get<WalletHistory[]>(`${this.environment.appConfig.apiBaseUrl}/${policyGroupId}/user/${userId}/wallet/transactions`, {
        }).pipe(
          tap((response) => {
            this._walletHistory = response || [];
          })
        );
      })
    );
  }
}
